import { render, staticRenderFns } from "./step5-submitRegistration.vue?vue&type=template&id=5f35b90c&scoped=true"
import script from "./step5-submitRegistration.vue?vue&type=script&lang=js"
export * from "./step5-submitRegistration.vue?vue&type=script&lang=js"
import style0 from "./step5-submitRegistration.vue?vue&type=style&index=0&id=5f35b90c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f35b90c",
  null
  
)

export default component.exports